import styled from 'styled-components';

import { ScLocalePopup } from '../CheckLocale/styled';
import { ScModalContent } from '@/components/Modal/styled';
import { device, typography } from '@/styles/helpers';

export const ScKnowYourLimitModalWrapper = styled(ScModalContent)`
  @media (${device.mobile}) {
    padding: 0 8px;
  }
`;

export const ScKnowYourLimitModal = styled(ScLocalePopup)`
  display: flex;
  padding: 32px;
  width: 100%;
  max-width: 480px;
  gap: 0;

  a {
    color: ${({ theme }) => theme.secondaryColor};
    text-decoration: underline;
    font-weight: 700;
    cursor: pointer;
    font-weight: bold;
    transition: 0.3s;

    &:hover {
      color: ${({ theme }) => theme.secondaryColorHover} !important;
    }
  }

  .title {
    ${typography['headline2']}
    text-transform: uppercase;
    margin: 32px 0 16px;
  }

  @media (${device.mobile}) {
    padding: 32px 16px;

    .title {
      ${typography['headline2mobile']}
    }
  }
`;
